module.exports = __webpack_public_path__ + "static/media/suslogo_roundedcorners.e52e0f4e.svg";